import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import reportWebVitals from './reportWebVitals';
import ReactGA from "react-ga4";
import { GA_MEASUREMENT_ID } from "./constants";
import Main from './main';

const container = document.getElementById('root')!;
const root = createRoot(container);
ReactGA.initialize(GA_MEASUREMENT_ID); // Initializes Google Analytics GA4

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Main />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
